import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCoinSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <circle
        cx="29.7505"
        cy="29.7505"
        r="23.7505"
        stroke="url(#paint0_linear_6052_11558)"
        strokeWidth="4"
      />
      <path
        d="M29.8293 20V19M29.8293 40V41M34.0125 24C33.1775 22.8044 31.6168 22 29.8293 22H29.2927C26.9219 22 25 23.5919 25 25.5556V25.7082C25 27.1128 25.9581 28.3968 27.4748 29.0249L32.1837 30.9751C33.7005 31.6032 34.6585 32.8872 34.6585 34.2918C34.6585 36.3398 32.6541 38 30.1816 38H29.8293C28.0418 38 26.4811 37.1956 25.6461 36"
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6052_11558"
          x1="29.7505"
          y1="4"
          x2="29.7505"
          y2="55.501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgCoinSmall);
export default ForwardRef;
